import { NgModule } from "@angular/core"
import { RouterModule, Routes } from "@angular/router"
import { OurMissionComponent } from "./our-mission/our-mission.component"
import { ErrorComponent } from "../error/error.component"
import { TrustAndPrivacyComponent } from "./trust-and-privacy/trust-and-privacy.component"
import { AboutComponent } from "./about.component"
import { OurContentComponent } from "./our-content/our-content.component"
import { ABOUT_ROUTES } from "../services/about.service"
import { OurImpactComponent } from "./our-impact/our-impact.component"
import { TeachingWithPbsComponent } from "./teaching-with-pbs/teaching-with-pbs.component"

const [ourMission, ourContent, ourImpact, teachingWithPbs, trustAndPrivacy] = ABOUT_ROUTES

const routes: Routes = [
    {
        path: "",
        component: AboutComponent,
        children: [
            { path: ourMission.routerLink, component: OurMissionComponent },
            { path: ourContent.routerLink, component: OurContentComponent },
            { path: ourImpact.routerLink, component: OurImpactComponent },
            { path: teachingWithPbs.routerLink, component: TeachingWithPbsComponent },
            { path: trustAndPrivacy.routerLink, component: TrustAndPrivacyComponent },
            { path: "", redirectTo: "our-mission", pathMatch: "full" },
            { path: "**", component: ErrorComponent },
        ],
    },
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class AboutRoutingModule {}
